import React, { useEffect, useState } from "react";
import {
    Box,
    ButtonStyled,
    FormEleWrapper,
    HeadingStyled,
    LabelStyled,
    SubHeadingStyled,
    TextStyled,
} from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import FloatingInput from "../../../components/common/inputFields/FloatingInput";
import { Camera, PlaceholderImg, ProfileImg, ProfileImgLarge } from "../../../components/styled/AllImages";
import { useForm } from "react-hook-form";
import PhoneInputField from "../../../components/common/inputFields/PhoneInput";
import ValidationController from "../../../components/common/inputFields/ValidationController";
import ImageUpload from "../../../components/common/uploadFiles/imagesUpload";
import ProfileUpload from "../../../components/common/uploadFiles/profileUpload";
import { Form } from "react-bootstrap";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useUser } from "../../../context/userContext";
import ProfileApi from "../../../services/api/profileApi";
import { toast } from "react-toastify";

const AccountSetting = () => {
    const { t } = useTranslation();
    const { user, fetchUserInfo } = useUser();
    const [profileImg, setProfileImg] = useState(null);
    const [loading, setLoading] = useState(false);
    
    const {
        register,
        control,
        handleSubmit,
        reset,
        formState: { errors },
        setValue, // React Hook Form function to set input values
    } = useForm();


    useEffect(() => {
        if (user) {
            // Pre-fill form inputs with user data
            setValue("name", user.name || "");
            setValue("email", user.email || "");
            setValue("phone", user.phone || "");
            const baseAssetURL = process.env.REACT_APP_ASSET_URL;
            const profileUrl = user.profile ? `${baseAssetURL}/${user.profile}` : PlaceholderImg;
            setProfileImg(profileUrl);

        }
    }, [user, setValue]); // Dependency array to update when user or setValue changes
    

    
    const onSubmit = async (formData) => {
        try {
          setLoading(true);

          // Create a FormData object
          const updatedData = new FormData();
          updatedData.append("action", "create");

          // Append form fields to FormData
          Object.entries(formData).forEach(([key, value]) => {
              updatedData.append(key, value);
          });

          // Append the logo file, if selected
          /* if (profileImg) {
              updatedData.append("profile", profileImg);
          } else {
              console.error("No file selected for profile");
          } */

          // Check if the profile image was removed
        if (profileImg && !updatedData.has("profile")) {
            updatedData.append("profile", profileImg); // Send the new image to the backend
        }

          // Debugging: Log FormData keys
        //   for (let pair of updatedData.entries()) {
        //       console.log(`${pair[0]}:`, pair[1]);
        //   }

          const response = await ProfileApi.updateProfile(updatedData);
          if (response.code === 200) {
            toast.success(`${t('Info')} ${t('Updated_Successfully')}`);
            fetchUserInfo();
            reset();
            // navigate("/settings/establishment")
          }
          if (response.code === 100 || response.code === 204) {
                toast.error(response.message);
            }
        } catch (error) {
        } finally {
          setLoading(false);
        }
    };

    return (
        <>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Box className="profileAvatarContainer">
                    <Box className="profileAvatarImg">
                        <ValidationController
                            name={"profile"}
                            validationConfig={{
                                required: false,
                            }}
                            errors={errors}
                            control={control}
                            renderer={({ field }) => (
                                <ProfileUpload
                                    UploadImage="UploadLogo"

                                    // onFileSelect={field.onChange} // Pass react-hook-form's onChange
                                    onFileSelect={(file) => {
                                        field.onChange(file); // Update form field
                                        setProfileImg(file); // Update logo file state
                                    }}
                                    initialImage={profileImg} // Pass the preloaded image URL
                                />
                            )}
                        />
                        {/* <Box className="profileAvatarImgContainer">
                            <img className="profileAvatar" src={ProfileImgLarge} />
                            <Box className="profileCamera">
                                <Camera />
                            </Box>
                        </Box> */}
                        <Box className="profileUserNameWrapper">
                            <HeadingStyled color="var(--text)" size="24px">
                                {user?.name}
                            </HeadingStyled>
                            <TextStyled lh="1">
                                {user?.position || ""}
                            </TextStyled>
                        </Box>
                    </Box>
                </Box>
                <Box className="profileContentData pt-2">
                    <FormEleWrapper className="pt-0">
                        <ValidatedInput
                            name="name"
                            type="input"
                            fieldType="text"
                            placeholder="name"
                            label="name"
                            className="combined px-0"
                            staric="staric"
                            register={register}
                            errors={errors}
                            validationRules={{
                                required: true,
                            }}
                        />
                        <ValidatedInput
                            name="email"
                            type="input"
                            fieldType="text"
                            placeholder={"Email"}
                            label="Email"
                            className="combined px-0"
                            staric="staric"
                            errors={errors}
                            register={register}
                            validationRules={{
                                required: true,
                            }}
                        />
                        <PhoneInputField
                            name="phone"
                            label={"Phone"}
                            placeholder={"Phone"}
                            register={register}
                            control={control}
                            errors={errors}
                            staric={true}
                            validationRules={{
                                required: false,
                            }}
                            className={"my-3 combined p-0"}
                        />

                    </FormEleWrapper>
                    <Box className="commonBtns px-0">
                        {/* <ButtonStyled
                            bg="var(--bgSecondary)"
                            label={t("Cancel")}
                            color="var(--text2)"
                            type="button"
                        ></ButtonStyled> */}
                        <ButtonStyled label={t("Update")} type="submit" isLoading={loading}></ButtonStyled>
                    </Box>
                </Box>
            </Form>
        </>
    );
};

export default AccountSetting;
